import * as React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { useAppConfig } from '../hooks/useAppConfig';

export type AppRouterProps = {
  /**
   * Kontext aplikace, předává se pouze pokud se liší od kontektu celé aplikace, použito např. u confu,
   * kde aplikace běží v Tomcat např. jako /mipo, ale conf běží jako /mipo/conf,
   * potom se zde musí předat kontext modulu BEZ kontektu aplikace, tedy předá se /conf.
   * Pokud aplikace běží v root, tak se pro případ conf předá opět /conf.
   *
   * Do browser router se reálně předá serverContextPath + moduleContextPath.
   */
  moduleContextPath?: string;
};

/**
 * Router aplikace.
 * @param children
 * @constructor
 */
export const AppRouter: React.FC<React.PropsWithChildren<AppRouterProps>> = ({
  moduleContextPath,
  children,
}) => {
  const { serverContextPath } = useAppConfig();
  return (
    <BrowserRouter
      key="router"
      basename={moduleContextPath ? serverContextPath + moduleContextPath : serverContextPath}
    >
      {children}
    </BrowserRouter>
  );
};
